export { default as InputLabel } from './input-label';